import * as rrd from 'react-router-dom';

const { useLocation } = rrd.default ?? rrd;

const useIsActiveTab = (tab) => {
  const { pathname } = useLocation();

  return pathname.endsWith(`/${tab}`);
};

export default useIsActiveTab;
